import { useEffect, useState, type JSX } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { DialMark } from '@procuai/ui';
import { consumeLink, ApiError } from '../api.js';

/** Consumes the magic-link token from the URL (?token=...) and lands the session in the shell. */
export function Verify(): JSX.Element {
  const navigate = useNavigate();
  const [msg, setMsg] = useState('Signing you in...');
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) {
      setIsError(true);
      setMsg('This sign-in link is missing its token. Please request a new one.');
      return;
    }
    consumeLink(token)
      .then((r) => {
        if (r.status === 'ok') navigate({ to: '/' });
        else if (r.status === 'totp_required') setMsg('This account needs a second factor, which is being set up.');
        else setMsg('This account belongs to several organisations; the chooser is coming soon.');
      })
      .catch((err) => {
        setIsError(true);
        setMsg(err instanceof ApiError ? err.message : 'This link is invalid or has expired. Please request a new one.');
      });
  }, [navigate]);

  return (
    <div className="auth">
      <div className="auth-card">
        <div className="auth-brand">
          <DialMark size={26} />
          <span className="auth-wordmark">procu<span>ai</span></span>
        </div>
        <div className={isError ? 'auth-msg error' : 'auth-msg'}>{msg}</div>
      </div>
    </div>
  );
}
